document.addEventListener('DOMContentLoaded', () => {
    const panels = document.querySelectorAll('.block--rusvm-accordion-panel');

    function create_block_rusvm_accordion_panel() {
        return {
            block: null,
            questionSection: null,
            answerSection: null,
            dividerBar: null,

            init: function (block) {
                this.block = block;
                this.setupPanel();
            },

            setupPanel: function () {
                if (!this.block) return;

                // Find the question and answer sections (core/group blocks with specific classes)
                this.questionSection = this.block.querySelector('.accordion-question');
                this.answerSection = this.block.querySelector('.accordion-answer');

                if (!this.questionSection || !this.answerSection) return;

                // Create and insert the divider bar after the question section
                this.createDividerBar();

                // Set initial state
                const isExpanded = this.block.classList.contains('is-expanded');
                this.answerSection.setAttribute('aria-hidden', !isExpanded);
                this.questionSection.setAttribute('aria-expanded', isExpanded);
                this.questionSection.setAttribute('role', 'button');
                this.questionSection.setAttribute('tabindex', '0');

                // Handle question clicks
                this.questionSection.addEventListener('click', (e) => {
                    this.toggle();
                });

                // Handle divider clicks
                if (this.dividerBar) {
                    this.dividerBar.addEventListener('click', (e) => {
                        this.toggle();
                    });
                }

                // Handle keyboard navigation
                this.questionSection.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        this.toggle();
                    }
                });
            },

            createDividerBar: function () {
                // Create divider bar element
                this.dividerBar = document.createElement('div');
                this.dividerBar.className = 'accordion-divider-bar';
                this.dividerBar.innerHTML = '<span class="accordion-divider"></span>';
                this.dividerBar.style.cursor = 'pointer';

                // Insert after question section
                this.questionSection.after(this.dividerBar);
            },

            toggle: function () {
                const isExpanded = this.block.classList.contains('is-expanded');

                if (isExpanded) {
                    this.collapse();
                } else {
                    this.expand();
                }
            },

            expand: function () {
                this.block.classList.add('is-expanded');
                this.answerSection.setAttribute('aria-hidden', 'false');
                this.questionSection.setAttribute('aria-expanded', 'true');
            },

            collapse: function () {
                this.block.classList.remove('is-expanded');
                this.answerSection.setAttribute('aria-hidden', 'true');
                this.questionSection.setAttribute('aria-expanded', 'false');
            }
        };
    }

    panels.forEach(block => {
        const instance = create_block_rusvm_accordion_panel();
        instance.init(block);
    });
});
